// The browser has its own Blob type (https://developer.mozilla.org/en-US/docs/Web/API/Blob),
// so we need a different name for Benchling blobs

export interface PreviewFile {
  id: string;
  url: string;
  previewType: string;
  availablePreviewTypes: Array<string>;
}

export interface BenchlingBlob {
  id: string;
  url: string;
  name: string;
  previewFile: PreviewFile | null;
  pdfPreviewFile?: PreviewFile | null;
  link_type?: 'result_blob';
  uploadStatus?: BlobUploadStatus;
}

export interface SanitizedBenchlingBlob {
  id: string;
  url: string;
  name: string;
  previewFile: PreviewFile | null;
  link_type?: 'result_blob';
}

export enum BlobUploadStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  ABORTED = 'ABORTED',
}

/**
 * The representation of a blob in the Warehouse.
 * WarehouseBlob stores a full external URL, rather than a relative path.
 *
 * See `get_blob_warehouse_value.py` for how a blob maps into the warehouse.
 */
export type WarehouseBlob = Pick<BenchlingBlob, 'id' | 'url' | 'name'>;
